<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>New Announcement</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout>
            <v-flex>
              <div class="subtitle-2 mb-1">
                What's the title of the Announcement?
              </div>
              <v-text-field
                v-model="data.title"
                hide-details
                dense
                outlined
                placeholder="Announcement Title"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Subtitle</div>
              <v-text-field
                v-model="data.subtitle"
                hide-details
                dense
                outlined
                placeholder="Subtitle"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Placement</div>
              <v-text-field
                v-model="data.placement"
                hide-details
                dense
                outlined
                placeholder="Ex: mapFeed"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Schedule At</div>
              <v-text-field
                readonly
                v-model="scheduledAtDateString"
                hide-details
                dense
                outlined
                placeholder="Scheduled Date"
                @click="openScheduleDateDialog"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Expires At</div>
              <v-text-field
                v-model="expiresAtDateString"
                readonly
                hide-details
                dense
                outlined
                placeholder="Expire Date"
                @click="openExpiryDateDialog"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Region</div>
              <v-select
                outlined
                dense
                hide-details
                return-object
                :items="regions"
                v-model="region"
                item-text="name"
                placeholder="Region"
              >
              </v-select>
            </v-flex>
          </v-layout>

          <v-layout class="mt-3">
            <div class="subtitle-1 font-weight-medium">Card Options</div>
          </v-layout>

          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Text Color</div>
              <v-text-field
                v-model="data.textColor"
                hide-details
                dense
                outlined
                placeholder="Ex: #FFCDD2"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Background Color</div>
              <v-text-field
                v-model="data.backgroundColor"
                hide-details
                dense
                outlined
                placeholder="Ex: #FFCDD2"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Icon Name</div>
              <v-text-field
                v-model="data.icon.name"
                hide-details
                dense
                outlined
                placeholder="Ex: gift"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Icon Type</div>
              <v-text-field
                v-model="data.icon.type"
                hide-details
                dense
                outlined
                placeholder="Ex: MaterialCommunityIcons"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout class="mt-3">
            <div class="subtitle-1 font-weight-medium">
              Navigation Button Options
            </div>
          </v-layout>

          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Action</div>
              <v-text-field
                v-model="data.navigate.action"
                hide-details
                dense
                outlined
                placeholder="Ex: Redeem"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">To</div>
              <v-text-field
                v-model="data.navigate.to"
                hide-details
                dense
                outlined
                placeholder="Ex: Vibez"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Text Color</div>
              <v-text-field
                v-model="data.navigate.textColor"
                hide-details
                dense
                outlined
                placeholder="Ex: #ffcc00"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Background Color</div>
              <v-text-field
                v-model="data.navigate.backgroundColor"
                hide-details
                dense
                outlined
                placeholder="Ex: #ffcc00"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <!-- <v-layout class="mt-3">
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Latitude</div>
              <v-text-field
                v-model="latitude"
                hide-details
                dense
                outlined
                placeholder="Latitude"
              ></v-text-field>
            </v-flex>
            <v-flex class="ml-1">
              <div class="subtitle-2 mb-1">Longitude</div>
              <v-text-field
                v-model="longitude"
                hide-details
                dense
                outlined
                placeholder="Logitude"
              ></v-text-field>
            </v-flex>
          </v-layout> -->
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Schedule
        </v-btn>
      </v-card-actions>
    </v-card>
    <!-- <v-dialog v-model="scheduleDateDialog" width="300">
      <v-card>
        <v-card-title>
          <v-layout>
            <v-flex> Schedule Date </v-flex>
            <v-flex text-right>
              <v-btn icon @click="scheduleDateDialog = false">
                <v-icon> mdi-close </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-date-picker v-model="scheduledAtDateField" />
      </v-card>
    </v-dialog>
    <v-dialog v-model="expiryDateDialog" width="300">
      <v-card>
        <v-card-title>
          <v-layout>
            <v-flex> Expire Date </v-flex>
            <v-flex text-right>
              <v-btn icon @click="expiryDateDialog = false">
                <v-icon> mdi-close </v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-date-picker v-model="expiresAtDateField" />
      </v-card>
    </v-dialog> -->
    <time-and-date-select-dialog
      @onDateSelected="onExpiryDateSelected"
      ref="ExpiryTimeAndDateDialogRef"
    />
    <time-and-date-select-dialog
      @onDateSelected="onScheduleDateSelected"
      ref="ScheduleTimeAndDateDialogRef"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import firebase from "firebase";
import { auth } from "@/plugins/firebase";
import moment from "moment";
import TimeAndDateSelectDialog from "./TimeAndDateSelectDialog.vue";
export default {
  props: {
    selectedRegion: {
      type: Object,
      default: function () {
        return {};
      },
    },
    collection: {
      type: String,
      default: function () {
        return {};
      },
    },
  },
  components: {
    TimeAndDateSelectDialog,
  },
  data() {
    return {
      dialog: false,
      scheduleDateDialog: false,
      expiryDateDialog: false,
      scheduledAtDateField: "",
      expiresAtDateField: "",
      scheduledAt: "",
      region: "",
      state: "",
      createdBy: "",
      data: {
        backgroundColor: "",
        expiresAt: "",
        icon: {
          name: "",
          type: "",
        },
        location: {
          latitude: "",
          longitude: "",
        },
        navigate: {
          action: "",
          backgroundColor: "",
          textColor: "",
          to: "",
        },
        placement: "",

        subtitle: "",
        textColor: "",
        title: "",
      },
    };
  },
  computed: {
    ...mapState("$_home", ["regions"]),
    scheduledAtDateString() {
      if (this.scheduledAtDateField) {
        return this.iMoment(this.scheduledAtDateField);
      } else {
        return this.scheduledAt;
      }
    },
    expiresAtDateString() {
      if (this.expiresAtDateField) {
        return this.iMoment(this.expiresAtDateField);
      } else {
        return this.data.expiresAt;
      }
    },

    changeFields() {
      return {
        scheduledAt: this.iMoment(this.scheduledAtDateField),
        state: "scheduled",

        type: "announcement",
        region: this.region,
        createdBy: {
          id: auth.currentUser.uid,
          email: auth.currentUser.email,
          name: auth.currentUser.displayName,
        },
        data: {
          backgroundColor: this.data.backgroundColor,
          expiresAt: this.iMoment(this.expiresAtDateString),
          icon: {
            name: this.data.icon.name,
            type: this.data.icon.type,
          },
          location: new firebase.firestore.GeoPoint(
            parseFloat(this.region.latitude),
            parseFloat(this.region.longitude)
          ),
          navigate: {
            action: this.data.navigate.action,
            backgroundColor: this.data.navigate.backgroundColor,
            textColor: this.data.navigate.textColor,
            to: this.data.navigate.to,
          },
          placement: this.data.placement,
          subtitle: this.data.subtitle,
          textColor: this.data.textColor,
          title: this.data.title,
        },
      };
    },
  },
  mounted() {
    this.getRegions({ collection: "regions", mutation: "updateRegions" });
  },
  methods: {
    ...mapActions({
      createNewAnnouncement: "$_content/createNewContent",
      getRegions: "$_home/getContent",
      getAnnouncements: "$_content/getContent",
      getAnnouncementsByRegion: "$_content/getContentByRegion",
    }),
    iMoment(date) {
      if (date) {
        // console.log(date);
        return moment(date).toDate();
      }
      return new Date();
    },
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    openExpiryDateDialog() {
      this.$refs.ExpiryTimeAndDateDialogRef.toggleDialog(
        this.expiresAtDateField
      );
    },
    onExpiryDateSelected(dateTime) {
      // console.log("Expiry Selected Date and Time: ", dateTime);
      this.expiresAtDateField = dateTime;
    },
    openScheduleDateDialog() {
      this.$refs.ScheduleTimeAndDateDialogRef.toggleDialog(
        this.scheduledAtDateField
      );
    },
    onScheduleDateSelected(dateTime) {
      // console.log("Scheduled Selected Date and Time: ", dateTime);
      this.scheduledAtDateField = dateTime;
    },
    cancel() {
      this.scheduledAtDateField = "";
      this.expiresAtDateField = "";
      this.scheduledAt = "";
      this.region = "";
      this.state = "";

      this.data = {
        backgroundColor: "",
        expiresAt: "",
        icon: {
          name: "",
          type: "",
        },
        location: {
          latitude: "",
          longitude: "",
        },
        navigate: {
          action: "",
          backgroundColor: "",
          textColor: "",
          to: "",
        },
        placement: "",

        subtitle: "",
        textColor: "",
        title: "",
      };
      this.dialog = false;
    },
    save() {
      // console.log(this.changeFields);
      this.createNewAnnouncement({
        details: this.changeFields,
        collection: this.collection,
        type: "Announcement",
      }).then(() => {
        this.dialog = false;
        this.getAnnouncementsByRegion({
          type: "announcement",
          collection: this.collection,
          mutation: "updateAnnouncements",
          region: this.selectedRegion,
        });
      });
    },
  },
};
</script>

<style>
</style>

          